import { literal, TypeOf, union } from 'zod/v4'

export const ApplySurveyVariantValidator = union([
  literal('control'),
  literal('control-desktop'),
  literal('control-mobile'),
  literal('desktop-1'),
  literal('desktop-2'),
  literal('mobile-1'),
  literal('mobile-2'),
])

export type ApplySurveyVariant = TypeOf<typeof ApplySurveyVariantValidator>
